export enum ServiceJobResolutionNextServiceDue {
    NotRequired = "Not Required",
    SixMonths = "6 Months",
    TwelveMonths = "12 Months",
}